import { render, staticRenderFns } from "./BuyVip.vue?vue&type=template&id=6ab25f1c&scoped=true"
import script from "./BuyVip.vue?vue&type=script&lang=js"
export * from "./BuyVip.vue?vue&type=script&lang=js"
import style0 from "./BuyVip.vue?vue&type=style&index=0&id=6ab25f1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab25f1c",
  null
  
)

export default component.exports